module.exports = __webpack_public_path__ + "static/media/m1_agency.fcaf70f2.png";